<template>
    <div class="form form__cost">
        <label
            v-if="label"
            :for="name | toKebabCase"
            class="form__cost_title"
        >{{label | toCapitalize}}<span class="asterisk" v-if="required">*</span></label>
        <div class="columns is-vcentered">
            <div class="column">
                <form-price
                    :class="'form__cost_input_number'"
                    :name="name | toKebabCase"
                    :data-vv-as="label.toLowerCase()"
                    :disabled="disabled"
                    v-model="newValueCost"
                />
                <span
                    class="form__error form__cost_error"
                    v-if="errors.first(toKebabCase(name))"
                >{{ errors.first(toKebabCase(name)) }}</span>
            </div>
            <div class="column is-narrow">
                <div :class="[
                'form__cost_fields',
                 items.length > 1 ? 'form__cost_fields--custom-navi' : '']">
                    <fieldset>
                        <template
                            v-for="(item, index) in items"
                        >
                            <label
                                :for="(name + '-' +  item.value) | toKebabCase"
                                :key="index"
                            >
                                <input
                                    type="radio"
                                    class="form__cost_input_radio"
                                    :id="(name + '-' +  item.value) | toKebabCase"
                                    :title="item.name | toKebabCase"
                                    :value="item.value | toKebabCase"
                                    :disabled="disabled"
                                    v-model="newValueCostPeriod"
                                    @click="emitFocus"
                                    @blur="emitBlur"
                                >
                                <span class="form__cost_input_radio_text">{{item.name | toCapitalize}}</span>
                            </label>
                        </template>
                    </fieldset>
                </div>
            </div>
        </div>
        <template v-if="$slots.default">
            <div class="form__cost_hint">
                <slot></slot>
            </div>
        </template>
    </div>
</template>

<script>
import { VMoney } from 'v-money'
import FormPrice from '@/components/default/forms/FormPrice'
import { toKebabCase } from '@/functions'

export default {
  components: { FormPrice },
  name: 'form-cost',
  data () {
    return {
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        min: '10',
        max: 10,
        masked: false
      }
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true,
      default: 'Label'
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      required: true
    },
    valueCost: {
      type: [String, Number],
      required: true
    },
    valueCostPeriod: {
      type: String,
      required: true,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    newValueCost: {
      get () {
        return this.valueCost
      },
      set (value) {
        this.$emit('emit-value-cost', value)
      }
    },
    newValueCostPeriod: {
      get () {
        return this.valueCostPeriod
      },
      set (value) {
        this.$emit('emit-value-cost-period', value)
      }
    }
  },
  methods: {
    emitFocus () {
      const field = this.$validator.errors.items.find(obj => obj.field === toKebabCase(this.name))
      this.$validator.pause()
      if (field) {
        this.$validator.reset(field)
      }
      this.$emit('emit-focus')
    },
    emitBlur () {
      const field = this.$validator.errors.items.find(obj => obj.field === toKebabCase(this.name))
      this.$validator.resume()
      if (field) {
        this.$validator.reset(field)
      }
      this.$emit('emit-blur')
    }
  },
  directives: { money: VMoney }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formcost";
</style>
